module.exports = __webpack_public_path__ + "static/media/sernhac_tunnel.e77af94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/sernhac_tunnel.png
// module id = 753
// module chunks = 0